// src/admin/pages/PlanListPage.jsx — superadmin plan settings (route /admin/plans).
import React, { useState, useEffect, useCallback } from 'react';
import AdminTable from '../components/AdminTable.jsx';
import PlanModal from './PlanModal.jsx';
import { adminListPlans } from '../adminApi.js';
import { formatCredits } from '../../utils/creditsFormat.js';

const btnStyle = (color = '#E8002D') => ({
  display: 'inline-flex', alignItems: 'center', gap: '6px',
  padding: '8px 14px', borderRadius: '8px', border: 'none',
  background: color, color: '#fff', fontSize: '13px', fontWeight: 600,
  cursor: 'pointer', fontFamily: "'DM Sans', sans-serif",
});

export default function PlanListPage() {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  const [editing, setEditing] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      setPlans(await adminListPlans());
    } catch (err) {
      setError(err.message);
      setPlans([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const columns = [
    { key: 'display_name', label: 'Nome piano' },
    { key: 'monthly_credits', label: 'Crediti mensili', width: '180px', render: (row) => formatCredits(row.monthly_credits) },
    {
      key: 'active', label: 'Stato', width: '100px',
      render: (row) => (
        <span style={{ color: row.active ? '#10B981' : '#EF4444', fontSize: '12px' }}>
          {row.active ? 'Attivo' : 'Disattivato'}
        </span>
      ),
    },
  ];

  return (
    <div style={{ padding: '32px 40px', fontFamily: "'DM Sans', sans-serif", color: '#1d1d1f', maxWidth: '900px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '24px', gap: '12px' }}>
        <div>
          <h1 style={{ fontSize: '22px', fontWeight: 700, marginBottom: '4px' }}>Piani crediti</h1>
          <p style={{ color: '#6c6c6d', fontSize: '13px', margin: 0 }}>
            Gestisci i piani; assegna un piano a un tenant dalla sua scheda in Gestione tenant
          </p>
        </div>
        <button onClick={() => { setEditing(null); setModalOpen(true); }} style={btnStyle()}>+ Crea piano</button>
      </div>

      {error && (
        <div style={{ marginBottom: '16px', padding: '12px 16px', borderRadius: '8px', background: 'rgba(239,68,68,0.06)', border: '1px solid rgba(239,68,68,0.15)', color: '#EF4444', fontSize: '13px' }}>
          {error}
        </div>
      )}

      <div style={{ background: '#fff', borderRadius: '10px', border: '1px solid rgba(0,0,0,0.06)', padding: '24px' }}>
        <AdminTable
          columns={columns} rows={plans} loading={loading}
          emptyMessage="Nessun piano configurato"
          getRowKey={(row) => row.id}
          onRowClick={(row) => { setEditing(row); setModalOpen(true); }}
        />
      </div>

      <PlanModal open={modalOpen} plan={editing} onClose={() => setModalOpen(false)} onSaved={load} />
    </div>
  );
}
